"use client";

import {
  IconPickerField,
  type IconOption,
} from "@/app/studio/pages/[slug]/IconPickerField";

/** Curated, searchable icon set. Values are valid `light.svg` sprite names. */
export const ICON_PICKER_OPTIONS: IconOption[] = [
  { label: "Claims / checklist", value: "clipboard-list" },
  { label: "Clipboard", value: "clipboard" },
  { label: "Renewal / refresh", value: "arrows-rotate" },
  { label: "Trend line", value: "chart-line" },
  { label: "Bar chart", value: "chart-bar" },
  { label: "Document", value: "file-lines" },
  { label: "Blank file", value: "file" },
  { label: "Document (edit)", value: "file-pen" },
  { label: "Document (approved)", value: "file-circle-check" },
  { label: "Document (review)", value: "file-magnifying-glass" },
  { label: "Contract", value: "file-contract" },
  { label: "Compare / balance", value: "scale-balanced" },
  { label: "Compare", value: "code-compare" },
  { label: "Search", value: "magnifying-glass" },
  { label: "Coverage / shield", value: "shield-halved" },
  { label: "Umbrella / coverage", value: "umbrella" },
  { label: "Calculator / quote", value: "calculator" },
  { label: "Billing / dollar", value: "dollar-sign" },
  { label: "Receipt / invoice", value: "receipt" },
  { label: "Email", value: "envelope" },
  { label: "Call / phone", value: "phone" },
  { label: "Inbound call", value: "phone-volume" },
  { label: "Headset / support", value: "headset" },
  { label: "Chat", value: "comment" },
  { label: "Messages", value: "comments" },
  { label: "Message", value: "message" },
  { label: "Send", value: "paper-plane" },
  { label: "Inbox", value: "inbox" },
  { label: "Customers", value: "users" },
  { label: "Person", value: "user" },
  { label: "Agent", value: "user-tie" },
  { label: "Agreement / handshake", value: "handshake" },
  { label: "Auto / car", value: "car" },
  { label: "Home", value: "house-chimney" },
  { label: "Commercial / building", value: "building" },
  { label: "Health", value: "stethoscope" },
  { label: "Cargo / truck", value: "truck" },
  { label: "Checklist", value: "list-check" },
  { label: "List", value: "list" },
  { label: "Edit", value: "pen-to-square" },
  { label: "Clock", value: "clock" },
  { label: "History", value: "clock-rotate-left" },
  { label: "Calendar", value: "calendar" },
  { label: "Scheduled", value: "calendar-check" },
  { label: "Dashboard / gauge", value: "gauge" },
  { label: "Settings", value: "gear" },
  { label: "AI / sparkles", value: "sparkles" },
  { label: "AI assist", value: "wand-magic-sparkles" },
  { label: "Idea / lightbulb", value: "lightbulb" },
  { label: "Success / check", value: "circle-check" },
  { label: "Info", value: "circle-info" },
  { label: "Warning", value: "triangle-exclamation" },
  { label: "Secure / lock", value: "lock" },
  { label: "Key", value: "key" },
  { label: "Briefcase", value: "briefcase" },
  { label: "Folder", value: "folder-open" },
  { label: "Notification / bell", value: "bell" },
  { label: "Flag", value: "flag" },
  { label: "Star", value: "star" },
  { label: "Tag", value: "tag" },
];

/** Puck custom field: a searchable grid of icon previews. */
export function iconPickerField(
  label = "Icon",
  options: IconOption[] = ICON_PICKER_OPTIONS,
) {
  return {
    type: "custom" as const,
    label,
    render: ({
      value,
      onChange,
    }: {
      value: string;
      onChange: (value: string) => void;
    }) => (
      <IconPickerField
        value={typeof value === "string" ? value : ""}
        onChange={onChange}
        options={options}
      />
    ),
  };
}
